import React, { useContext, FC } from "react";
import { useNavigate, Link } from "react-router-dom";
import "../../../../styles/system.admin.scss";
import { SidebarContext } from "../../../auth/ProtectedRoute";
import { GroupDataType } from "../types/DataTypes";
const EditGroupBtn: FC<{ record: GroupDataType }> = ({ record }) => {
  const { userName, sidebarData } = useContext(SidebarContext);

  return (
    <div style={{ width: "100%" }}>
      <Link
        to={`edit-group/${record.id}`}
        state={{ userName: userName, sidebar: sidebarData }}
      >
        <button className="__btn">Edit Group</button>
      </Link>
    </div>
  );
};
export default EditGroupBtn;
